module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "ch01"
    }
  }, [_c('h1', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsuridl0007#rch01"
    }
  }, [_vm._v("Likely")])]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "sl"
  }, [_vm._v("Most days come")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("along like a child")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("kicking a stone")]), _vm._v(" "), _c('p', {
    staticClass: "slf"
  }, [_vm._v("down an alley")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("or like the way")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("the mail lies")]), _vm._v(" "), _c('p', {
    staticClass: "slf"
  }, [_vm._v("in the mailbox,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("its flag up. But")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("sometimes as")]), _vm._v(" "), _c('p', {
    staticClass: "slf"
  }, [_vm._v("you wander into")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("some old words,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("you feel yourself")]), _vm._v(" "), _c('p', {
    staticClass: "slf"
  }, [_vm._v("gliding on the morning,")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("maybe looking back")]), _vm._v(" "), _c('p', {
    staticClass: "sl"
  }, [_vm._v("over your shoulder.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef13b040","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wsu-ridl-0008.vue
// module id = 75
// module chunks = 0